// state
const state = () => ({
  all: [],
  marketPlaceExpire: Boolean,
  marketPlaceDateExpire: 0,
  voiceCallWarning: Boolean
});

// getters
const getters = {};

// actions
const actions = {
  async getAll({ commit }) {
    let Api = await import("../../services/endpoint/tenant.service.js");
    const queryString = "?type_id=1,2,3,12";
    let integrations = await Api.Integration.getIntegration(queryString);
    integrations = integrations.data.data;
    const newIntegrations = integrations.map(integration => {
      return {
        id: integration.id,
        name: integration.name,
        logo: ''
      };
    });

    // const integrations = [
    //   {
    //     id: 1,
    //     name: "Facebook",
    //     logo: require("@/assets/global_assets/images/facebook4.png"),
    //   },
    //   {
    //     id: 2,
    //     name: "Line",
    //     logo: require("@/assets/global_assets/images/Line.png"),
    //   },
    //   {
    //     id: 3,
    //     name: "Salepage",
    //     logo: require("@/assets/global_assets/images/Salepage.png"),
    //   },
    //   {
    //     id: 4,
    //     name: "Tiktok",
    //     logo: require("@/assets/global_assets/images/ic-tiktok.png"),
    //   },
    //   {
    //     id: 5,
    //     name: "Telesales",
    //     logo: require("@/assets/global_assets/images/ic-telesale.png"),
    //   },
    // ];
    commit('setIntegrations', newIntegrations);
  },

  getMarketPlaceExpire({ commit }, fields) {
    commit('getMarketPlaceExpire', fields);
  },
  getMarketPlaceDateExpire({ commit }, fields) {
    commit('getMarketPlaceDateExpire', fields);
  },
  getVoiceCallWarning({ commit }, fields) {
    commit('getVoiceCallWarning', fields);
  },
};

// mutations
const mutations = {
  setIntegrations(state, integrations) {
    state.all = integrations;
  },
  getMarketPlaceExpire(state, data) {
    state.marketPlaceExpire = data;
  },
  getMarketPlaceDateExpire(state, data) {
    state.marketPlaceDateExpire = data;
  },
  getVoiceCallWarning(state, data) {
    state.voiceCallWarning = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/integration.js